import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { functions, selectedWebEnvironment } from "../config/firebase";
import { paymentReturnLink } from "../utils/paymentReturnLink";

export const PaymentSuccess = () => {
	const location = useLocation();
	const appLink = paymentReturnLink(selectedWebEnvironment, functions.app.options.projectId, "success", location.search);

	useEffect(() => {
		if (!appLink) return undefined;
		const timeout = setTimeout(() => {
			window.location.href = appLink;
		}, 500);

		return () => clearTimeout(timeout);
	}, [appLink]);

	return (
		<div
			style={{
				textAlign: "center",
				padding: "100px 20px",
				fontFamily: "sans-serif",
			}}
		>
			<h2 style={{ color: "#333" }}>Return to Scerv</h2>
			<p style={{ fontSize: "18px", color: "#555" }}>
				Scerv will confirm your payment status when you return to the app.
			</p>

			{/* THE FIX: A physical button for iOS/Android to allow the redirect */}
			<div style={{ marginTop: "40px" }}>
				<p style={{ fontSize: "14px", color: "#888", marginBottom: "15px" }}>
					If you are not redirected automatically, tap the button below.
				</p>
				{appLink ? <a
					href={appLink}
					style={{
						display: "inline-block",
						backgroundColor: "#000",
						color: "#fff",
						padding: "16px 32px",
						textDecoration: "none",
						borderRadius: "8px",
						fontWeight: "bold",
						fontSize: "18px",
					}}
				>
					Return to Scerv App
				</a> : <p role="alert">App return is unavailable for this environment. Reopen Scerv directly.</p>}
			</div>
		</div>
	);
};

export const PaymentCancel = () => {
	const appLink = paymentReturnLink(selectedWebEnvironment, functions.app.options.projectId, "cancel");
	useEffect(() => {
		if (!appLink) return undefined;
		const timeout = setTimeout(() => {
			window.location.href = appLink;
		}, 500);
		return () => clearTimeout(timeout);
	}, [appLink]);

	return (
		<div
			style={{
				textAlign: "center",
				padding: "100px 20px",
				fontFamily: "sans-serif",
			}}
		>
			<h2 style={{ color: "#333" }}>Checkout Interrupted</h2>
			<p style={{ fontSize: "18px", color: "#555" }}>
				Return to Scerv to confirm your payment status before trying again.
			</p>

			<div style={{ marginTop: "40px" }}>
				<p style={{ fontSize: "14px", color: "#888", marginBottom: "15px" }}>
					If you are not redirected automatically, tap below.
				</p>
				{appLink ? <a
					href={appLink}
					style={{
						display: "inline-block",
						backgroundColor: "#000",
						color: "#fff",
						padding: "16px 32px",
						textDecoration: "none",
						borderRadius: "8px",
						fontWeight: "bold",
						fontSize: "18px",
					}}
				>
					Return to Scerv App
				</a> : <p role="alert">App return is unavailable for this environment. Reopen Scerv directly.</p>}
			</div>
		</div>
	);
};
